import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreditWrapperComponent } from './credit-wrapper/credit-wrapper.component';

const routes: Routes = [
  {
    path: '',
    component: CreditWrapperComponent,
    children: [
      {
        path: 'resolve',
        loadComponent: () => import('./credit-resolve-status/credit-resolve-status.component').then(
          c => c.CreditResolveStatusComponent
        ),
      },
      /*
      |--------------------------------------------------------------------------
      | Wallet Activation
      |--------------------------------------------------------------------------
      |
      */
      {
        path: 'overview',
        loadComponent: () => import('./wallet-activation/dashboard/credit-wallet-activation-dashboard.component').then(
          c => c.CreditWalletActivationDashboardComponent
        ),
        title: 'وام و اعتبار',
      },
      {
        path: 'pay-debt/:fundProviderCode',
        loadComponent: () => import('./wallet-activation/dashboard/credit-wallet-activation-dashboard.component').then(
          c => c.CreditWalletActivationDashboardComponent
        ),
      },
      {
        path: 'go-to-wallet/:creditId',
        loadComponent: () => import('./wallet-activation/dashboard/credit-wallet-activation-dashboard.component').then(
          c => c.CreditWalletActivationDashboardComponent
        ),
      },
      {
        path: 'wallet/tac',
        loadComponent: () => import('./wallet-activation/tac-page/credit-tac-page.component').then(
          c => c.CreditTacPageComponent
        ),
      },
      {
        path: 'wallet/activation/steps',
        loadComponent: () => import('./wallet-activation/activation-steps/credit-activation-steps.component').then(
          c => c.CreditActivationStepsComponent
        ),
      },
      {
        path: 'wallet/activation/steps/:fundProviderCode/:creditId',
        loadComponent: () => import('./wallet-activation/activation-steps/credit-activation-steps.component').then(
          c => c.CreditActivationStepsComponent
        ),
      },
      {
        path: 'wallet/activation/steps/:fundProviderCode/:creditId/:action',
        loadComponent: () => import('./wallet-activation/activation-steps/credit-activation-steps.component').then(
          c => c.CreditActivationStepsComponent
        ),
      },
      {
        path: 'wallet/activation/upload',
        loadComponent: () => import('./wallet-activation/credit-upload/credit-upload-document/credit-upload-document.component').then(
          c => c.CreditUploadDocumentComponent
        ),
      },
      {
        path: 'wallet/activation/cheque',
        loadChildren: () =>
          import('./wallet-activation/credit-cheque-step/credit-cheque-step.module').then((m) => m.CreditChequeStepModule),
      },
      {
        path: 'wallet/activation/payment/:fundProviderCode/:creditId',
        loadComponent: () => import('./wallet-activation/credit-payment-step/credit-payment-step.component').then(
          c => c.CreditPaymentStepComponent
        ),
      },
      {
        path: 'wallet/activation/payment/result/:fundProviderCode/:creditId',
        loadComponent: () => import('./wallet-activation/credit-payment-step/credit-payment-step-result/credit-payment-step-result.component').then(
          c => c.CreditPaymentStepResultComponent
        ),
      },
      {
        path: 'wallet/activation/pre-payment/:fundProviderCode/:creditId',
        loadComponent: () => import('./wallet-activation/credit-pre-payment-step/credit-pre-payment-step.component').then(
          c => c.CreditPrePaymentStepComponent
        ),
      },
      {
        path: 'wallet/activation/pre-payment/result/:fundProviderCode/:creditId',
        loadComponent: () => import('./wallet-activation/credit-pre-payment-step/credit-pre-payment-step-result/credit-pre-payment-step-result.component').then(
          c => c.CreditPrePaymentStepResultComponent
        ),
      },
      {
        path: 'wallet/activation/bank-account-verification/:fundProviderCode/:creditId',
        loadComponent: () => import('./wallet-activation/credit-bank-account-verification-step/credit-bank-account-verification-step.component').then(
          c => c.CreditBankAccountVerificationStepComponent
        ),
      },
      {
        path: 'wallet/activation/bank-account-verification/:fundProviderCode/:creditId/shahab-help',
        loadComponent: () => import('./wallet-activation/credit-bank-account-verification-step/credit-bank-account-verification-step-shahab-help/credit-bank-account-verification-step-shahab-help.component').then(
          c => c.CreditBankAccountVerificationStepShahabHelpComponent
        ),
      },
      {
        path: 'wallet/activation/digital-sign-contract/:fundProviderCode/:creditId',
        loadComponent: () => import('./wallet-activation/credit-digital-sign-contract-step/credit-digital-sign-contract-step.component').then(
          c => c.CreditDigitalSignContractStepComponent
        ),
      },
      {
        path: 'wallet/activation/generate-digital-sign-contract/kyc-result/:fundProviderCode/:creditId',
        redirectTo: 'wallet/activation/generate-digital-sign-contract/v2/:fundProviderCode/:creditId',
      },
      {
        path: 'wallet/activation/generate-digital-sign-contract/v2/:fundProviderCode/:creditId',
        loadChildren: () =>
          import('./wallet-activation/credit-generate-digital-signature-new/credit-generate-digital-signature.module').then(
            (m) => m.CreditGenerateDigitalSignatureModule,
          ),
      },
      {
        path: 'wallet/activation/signing-documents/:fundProviderCode/:creditId',
        loadComponent: () =>
          import('./wallet-activation/credit-signing-documents-step/credit-signing-documents-step.component').then(
            (c) => c.CreditSigningDocumentsStepComponent,
          ),
      },
      {
        path: 'wallet/activation/check-credit-file/:fundProviderCode/:creditId',
        loadComponent: () =>
          import('./wallet-activation/check-credit-file-step/check-credit-file-step/check-credit-file-step.component').then(
            (m) => m.CheckCreditFileStepComponent,
          ),
      },
      {
        path: 'wallet/activation/enote',
        loadChildren: () => import('./wallet-activation/credit-enote-step/credit-enote-step.module').then((m) => m.CreditEnoteStepModule),
      },
      {
        path: 'wallet/activation/account-block',
        loadChildren: () =>
          import('./wallet-activation/credit-account-block-step/credit-account-block-step.module').then(
            (m) => m.CreditAccountBlockStepModule,
          ),
      },
      {
        path: 'score/show',
        loadComponent: () => import('./wallet-activation/show-credit-score/show-credit-score.component').then(
          c => c.ShowCreditScoreComponent
        ),
      },
      {
        path: 'wallet/activation/profile/:fundProviderCode/:creditId',
        loadComponent: () => import('./wallet-activation/credit-profile-step/credit-profile-step.component').then(
          c => c.CreditProfileStepComponent
        ),
      },
      {
        path: 'wallet/detail',
        loadComponent: () => import('./credit-wallet-detail/credit-wallet-detail.component').then(
          c => c.CreditWalletDetailComponent
        ),
      },
      {
        path: 'wallet/detail/:fundProviderCode/:creditId',
        loadComponent: () => import('./credit-wallet-detail/credit-wallet-detail.component').then(
          c => c.CreditWalletDetailComponent
        ),
      },
      {
        path: 'wallet/detail/:creditId',
        loadComponent: () => import('./credit-wallet-detail/credit-wallet-detail.component').then(
          c => c.CreditWalletDetailComponent
        ),
      },
      {
        path: 'installment/pay',
        loadComponent: () => import('./credit-wallet-detail/credit-installment-payment/credit-installment-payment.component').then(
          c => c.CreditInstallmentPaymentComponent
        ),
      },
      {
        path: 'installment/pay/:creditId',
        loadComponent: () => import('./credit-wallet-detail/credit-installment-payment/credit-installment-payment.component').then(
          c => c.CreditInstallmentPaymentComponent
        ),
      },
      {
        path: 'installment/pay/bank-account/:creditId/:amount',
        loadComponent: () => import('./credit-wallet-detail/credit-installment-bank-account/credit-installment-bank-account.component').then(
          c => c.CreditInstallmentBankAccountComponent
        ),
      },
      {
        path: 'total-installments',
        loadComponent: () => import('./total-installments/total-installments.component').then(
          c => c.TotalInstallmentsComponent
        ),
      },
      {
        path: 'contract/detail/:contractTrackingCode/:creditId',
        loadComponent: () => import('./credit-wallet-detail/credit-wallet-contract-detail/credit-wallet-contract-detail.component').then(
          c => c.CreditWalletContractDetailComponent
        ),
      },
      {
        path: 'installment/pay/confirm',
        loadComponent: () => import('./credit-wallet-detail/installment-pay-confirm-neo/installment-pay-confirm-neo.component').then(
          c => c.InstallmentPayConfirmNeoComponent
        ),
      },
      {
        path: 'early-settlement/pay/:creditId/:amount',
        loadComponent: () => import('./credit-wallet-detail/credit-early-settlement/credit-early-settlement-payment-confirm/credit-early-settlement-payment-confirm.component').then(
          c => c.CreditEarlySettlementPaymentConfirmComponent
        ),
      },
      {
        path: 'early-settlement/pay-result/:creditId',
        loadComponent: () => import('./credit-wallet-detail/credit-early-settlement/credit-early-settlement-payment-result/credit-early-settlement-payment-result.component').then(
          c => c.CreditEarlySettlementPaymentResultComponent
        ),
      },
      {
        path: 'contract-purchase/:contractTrackingCode/:creditId',
        loadComponent: () => import('./credit-wallet-detail/credit-contract-transactions/credit-contract-transactions.component').then(
          c => c.CreditContractTransactionsComponent
        ),
      },
      {
        path: 'wallet-transactions/:creditId',
        loadComponent: () => import('./credit-wallet-detail/credit-wallet-transactions/credit-wallet-transactions.component').then(
          c => c.CreditWalletTransactionsComponent
        ),
      },
      {
        path: 'wallet/activated',
        loadComponent: () => import('./wallet-activation/wallet-activated/wallet-activated.component').then(
          c => c.WalletActivatedComponent
        ),
      },
      {
        path: 'wallet/activation/step–info',
        loadComponent: () => import('./wallet-activation/credit-upload/step-info/step-info.component').then(
          c => c.StepInfoComponent
        ),
      },
      {
        path: 'onboarding',
        loadComponent: () => import('./credit-onboarding/credit-onboarding.component').then(
          c => c.CreditOnboardingComponent
        ),
      },
      {
        path: 'volunteer/view',
        loadComponent: () => import('./credit-volunteer-page/credit-volunteer-page.component').then(
          c => c.CreditVolunteerPageComponent
        ),
      },
      {
        path: 'score',
        loadChildren: () =>
          import('./wallet-activation/credit-scoring-step/credit-scoring-step.module').then((m) => m.CreditScoringStepModule),
      },
      {
        path: 'smc-score',
        loadChildren: () =>
          import('./wallet-activation/credit-scoring-smc-step/credit-scoring-smc-step.module').then((m) => m.CreditScoringSmcStepModule),
      },
      {
        path: 'contract/detail/:contractTrackingCode/:fundProviderCode/:creditId',
        loadComponent: () => import('./credit-wallet-detail/credit-contract-detail/credit-contract-detail.component').then(
          c => c.CreditContractDetailComponent
        ),
      },
      {
        path: 'pre-register-by-campaign/:campaignId',
        loadComponent: () => import('./pre-registration-by-campaign-data/pre-registration-by-campaign-data.component').then(
          c => c.PreRegistrationByCampaignDataComponent
        ),
      },
      {
        path: 'transaction-detail/:trackingCode',
        loadComponent: () => import('./credit-transaction-detail/credit-transaction-detail.component').then(
          c => c.CreditTransactionDetailComponent
        ),
      },
      {
        path: 'payment-result/:transactionType',
        loadComponent: () => import('./credit-payment-callback/credit-payment-callback.component').then(
          c => c.CreditPaymentCallbackComponent
        ),
      },
      {
        path: 'final-contract/:fundProviderCode/:creditId',
        loadComponent: () => import('./credit-wallet-detail/credit-final-contract-page/credit-final-contract-page.component').then(
          c => c.CreditFinalContractPageComponent
        ),
      },
      {
        path: 'pre-register',
        loadChildren: () => import('./pre-registration/pre-registration.module').then((m) => m.PreRegistrationModule),
      },
      {
        path: 'wallet/activation/subscription',
        loadChildren: () =>
          import('./wallet-activation/credit-subscription/credit-subscription.module').then((m) => m.CreditSubscriptionModule),
      },
      {
        path: '',
        redirectTo: 'resolve',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreditRoutingModule {}
